export default __webpack_public_path__ + "static/media/check-solid.33faf9b7.svg";